// extracted by mini-css-extract-plugin
export default {"coverContainer":"TokenEnwDetailItem_coverContainer__FzT4s"};